import { render } from "./course-public.vue?vue&type=template&id=7d2d9ac0"
import script from "./course-public.vue?vue&type=script&lang=js"
export * from "./course-public.vue?vue&type=script&lang=js"

import "./course-public.vue?vue&type=style&index=0&id=7d2d9ac0&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__